import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import { CurrentOrganization, currentOrganization } from '../types/organization'
import { organizationArgs, OrganizationArgs } from '../types/organization-args'

export const organization: GraphQLFieldConfig<any, Context, OrganizationArgs> =
  {
    type: new GraphQLNonNull(currentOrganization),
    description: 'Get the current organization',
    args: organizationArgs,
    async resolve(_source, _args, context): Promise<CurrentOrganization> {
      const {
        organization: { name, organization_uuid: id }
      } = await context.connector.get(
        `/${_args.organizationUuid}/organizations?expand=freemium`
      )

      const {
        breakdown: { unused, used }
      } = await context.connector.get(`/${id}/licenses`)

      return {
        name,
        id,
        assessLicenseBreakdown: {
          unused,
          used
        }
      }
    }
  }
